import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { from, map, mergeMap, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PaymentBaseApi {

  constructor(private _http: HttpClient) {}

  downloadCreditConsumption$(clientId: string, month: string): Observable<{
    file: ArrayBuffer,
    contentType: string,
    contentDisposition: string
  }> {
    return this._http.post(
      `/api/billing/client/${clientId}/credit-export`,
      { month },
      { responseType: 'blob', observe: 'response' }
    ).pipe(
      mergeMap((data) => from(data.body.arrayBuffer()).pipe(
        map((buffer) => ({
          file: buffer,
          contentType: data.headers.get('Content-Type'),
          contentDisposition: data.headers.get('Content-Disposition')
        }))
      ))
    );
  }

}
